import React, { useMemo } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { PackagesInvoicesXMLSearch } from '../../components/PackagesInvoicesXML/PackagesInvoicesXMLSearch';
import { TabsHistory } from '../../../app/components/TabsHistory';
import {
  InvoiceTypeEnum,
  PackageTypeEnum,
} from '../../../common/pokCore/validation/enums';
import { useNavigation } from '../../../common/navigation';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { ExportFVZToXMLByType } from './ExportFVZToXMLByTypeView';

export const ExportFVZToXMLView: React.FC = () => {
  const pok = usePokCore();
  const nav = useNavigation();
  const { t, tk } = useTranslation('fvzLng');

  const onRowClick = (id: string) => {
    void nav.packagesFVZ(id);
  };

  const getDataPackages = useMemo(
    () =>
      ((pageSize, pageNumber, orderBy, orderDirection, filterText) =>
        pok.packagesXML.getAllByPortion(
          t,
          tk,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          PackageTypeEnum.Purchase,
        )) as GridGetterFunction,
    [pok.packagesXML, t, tk],
  );

  const getCountPackages = useMemo(
    () =>
      ((filterText: string) =>
        pok.packagesXML.getAllCount(
          filterText,
          PackageTypeEnum.Purchase,
        )) as GridCountFunction,
    [pok.packagesXML],
  );

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">{t(tk.finance.exportFvz)}</Card.Title>
        <TabsHistory
          activeKey="invoicesDomesticToSent"
          id="product"
          className="mb-3"
          mountOnEnter
          unmountOnExit
        >
          <Tab
            eventKey="invoicesDomesticToSent"
            title={t(tk.finance.invoicesDomesticToSent)}
            className="m-3"
          >
            <ExportFVZToXMLByType
              type={InvoiceTypeEnum.Domestic}
              isRepeat={false}
              title={t(tk.finance.createInvoicesDomesticToSent)}
            />
          </Tab>
          <Tab
            eventKey="invoicesForeignToSent"
            title={t(tk.finance.invoicesForeignToSent)}
            className="m-3"
          >
            <ExportFVZToXMLByType
              type={InvoiceTypeEnum.Foreign}
              isRepeat={false}
              title={t(tk.finance.createInvoicesForeignToSent)}
            />
          </Tab>
          <Tab
            eventKey="invoicesDomesticToSentAgain"
            title={t(tk.finance.invoicesDomesticToSentAgain)}
            className="m-3"
          >
            <ExportFVZToXMLByType
              type={InvoiceTypeEnum.Domestic}
              isRepeat={true}
              title={t(tk.finance.createInvoicesDomesticToSentAgain)}
            />
          </Tab>
          <Tab
            eventKey="invoicesForeignToSentAgain"
            title={t(tk.finance.invoicesForeignToSentAgain)}
            className="m-3"
          >
            <ExportFVZToXMLByType
              type={InvoiceTypeEnum.Foreign}
              isRepeat={true}
              title={t(tk.finance.createInvoicesForeignToSentAgain)}
            />
          </Tab>
          <Tab
            eventKey="packagesFVZ"
            title={t(tk.finance.packagesFVZ)}
            className="m-3"
          >
            <PackagesInvoicesXMLSearch
              getData={getDataPackages}
              getCount={getCountPackages}
              onRowClick={onRowClick}
              packageType={PackageTypeEnum.Purchase}
            />
          </Tab>
        </TabsHistory>
      </Card.Body>
    </Card>
  );
};
